import React, { FunctionComponent, useMemo } from "react";

const Footer:  FunctionComponent = () => {

  const currentYear = useMemo(() => {
    let currentDate = new Date(); 
    let currentYearFromDate = currentDate. getFullYear(); 
    return currentYearFromDate;
  },[]);
  
  return (
    <footer
      className="footer"
      
    >
      <div className="row">
        <div className="col-3 col-md-3">
      <img
        style={{
          maxWidth: "200px",
          width: "100%",
          height: "auto",
        }}
        src="/media/readycoach-logo.png"
        alt="ReadyCoach"
      />

        </div>
        <div className="col-7 col-md-5 text-center">
          {/* <LanguageSelector /> */}
          <a className="ml-3 localeBtn" href="/app/privacy">
            <span>Privacy Policy</span>
          </a>
          <a className="ml-3 localeBtn" href="/app/user-agreement">
            <span>User Agreement</span>
          </a>
          
        </div>
        <div className="col-2 col-md-4 text-right">
          
      <div>Copyright © {currentYear}</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
